import { useEffect, useState } from "react";
import { api, imageUrl } from "@/lib/api";
import { Link } from "react-router-dom";
import { UserCircle, MapPin, ArrowSquareOut, Images } from "@phosphor-icons/react";
import { Card } from "@/components/ui/card";

export default function Photographers() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/photographers").then((r) => setList(r.data)).catch(() => setList([])); }, []);

  return (
    <div className="mx-auto max-w-[1400px]">
      <p className="overline text-[#F27A54]">People</p>
      <h1 className="mt-1 font-display text-3xl font-black tracking-tight">Photographers</h1>
      <p className="mt-1 text-sm text-muted-foreground">Each photographer has a dedicated page with their photos organized into geographic folders.</p>

      {list === null ? (
        <p className="mt-8 text-muted-foreground">Loading…</p>
      ) : list.length === 0 ? (
        <div className="mt-16 grid place-items-center text-center">
          <UserCircle size={44} weight="thin" className="text-zinc-300" />
          <p className="mt-3 font-display font-bold">No photographers yet</p>
          <p className="text-sm text-muted-foreground">Add a Photographer to any photo (Photo → Correct tab) to build these pages.</p>
        </div>
      ) : (
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((ph) => (
            <Card key={ph.photographer} className="overflow-hidden rounded-md border border-border shadow-none transition-transform duration-200 hover:-translate-y-1 hover:shadow-sm">
              <Link to={`/photographers/${encodeURIComponent(ph.photographer)}`} className="block">
                <div className="relative aspect-[16/9] overflow-hidden bg-zinc-100">
                  <img src={imageUrl(ph.cover)} alt="" className="h-full w-full object-cover" />
                </div>
              </Link>
              <div className="p-4">
                <div className="flex items-center justify-between gap-2">
                  <Link to={`/photographers/${encodeURIComponent(ph.photographer)}`} className="flex items-center gap-2 font-display font-bold hover:text-[#F27A54]">
                    <UserCircle size={20} weight="fill" className="text-[#F27A54]" />{ph.photographer}
                  </Link>
                  {ph.photographer_url && <a href={ph.photographer_url} target="_blank" rel="noreferrer" className="text-[#F27A54]" title="Pulse profile"><ArrowSquareOut size={16} weight="bold" /></a>}
                </div>
                <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1 rounded-sm bg-zinc-100 px-2 py-0.5 font-semibold text-zinc-700"><Images size={12} weight="fill" />{ph.count}</span>
                  {ph.countries.slice(0, 3).map((c) => <span key={c} className="flex items-center gap-0.5"><MapPin size={11} weight="fill" />{c}</span>)}
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
